export default ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: (date, eventType, eventId, time, numberOfGuests = '') => {
            if (numberOfGuests) {
                numberOfGuests = `&guests=${numberOfGuests}`;
            }

            return api.get(`/api/${api.property()}/${availabilityApiService.switchEventType(eventType)}/${eventId}/quantity?date=${date}&time=${time}${numberOfGuests}`)
                .then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/services/quantity.api.service.js